import { User } from 'src/models/user';

export function getHeaderIdentity(user: User) {
  return {
    name: user.name,
    companyName: !user.is_root && user.role?.role_type === 'admin'
      ? user.parent?.company_name
      : user.company_name,
  };
}
